import React from 'react'
// @ts-expect-error - react-helmet types not available
import {Helmet} from 'react-helmet'
import type {RegisteredComponent} from '@builder.io/sdk-react'
interface TrustArcBannerProps {
    attributes?: Record<string, unknown>
    domain: string
    script?: string
    children?: React.ReactNode
}

const TrustArcBanner: React.FC<TrustArcBannerProps> = ({attributes, domain, script}) => {
    return (
        <>
            <Helmet>
                <script
                    id="trustarc"
                    type="text/javascript"
                    async
                    src={`https://consent.trustarc.com/notice?domain=${domain}&c=teconsent&js=nj&noticeType=bb&text=true&gtm=1&pcookie`}
                />
                {script && (
                    <script id="trustarc-script" async type="text/javascript">
                        {script}
                    </script>
                )}
            </Helmet>
            <div {...attributes} className="trust-arc-container" data-testid="trust-arc-container">
                <div id="consent_blackbar"></div>
                <div id="teconsent"></div>
            </div>
        </>
    )
}

export const TrustArcBannerDefinition = {
    name: 'TrustArcBanner',
    component: TrustArcBanner,
    override: true,
    shouldReceiveBuilderProps: {
        builderBlock: false,
        builderContext: true
    },
    static: true,
    isRSC: true,
    image: 'https://unpkg.com/css.gg@2.0.0/icons/svg/user.svg',
    inputs: [
        {
            name: 'domain',
            type: 'text',
            required: true,
            autoFocus: true,
            bubble: true,
            defaultValue: 'hsastore.com'
        },
        {
            name: 'script',
            type: 'longText',
            required: false,
            defaultValue: '',
            helperText: 'Optional custom script to run after the TrustArc banner is loaded'
        }
    ]
} satisfies RegisteredComponent

export default TrustArcBanner
